export const visit = (vm, at) => {
at({ "fr": { "pricing-page-components": { "phone-support": { "seePhoneNumber": "Voir le num\xE9ro de t\xE9l\xE9phone" } } } });
};